import * as React from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function SelectLabels({
  categoryData,
  text,
  valueKey,
  labelKey,
  required,
  onSelectChange,
  previousValue,
}) {
  const [selectedValue, setSelectedValue] = React.useState(previousValue || "");

  React.useEffect(() => {
    if (previousValue && previousValue !== selectedValue) {
      setSelectedValue(previousValue);
      onSelectChange(previousValue);
    }
  }, [previousValue, selectedValue, onSelectChange]);

  const handleChange = React.useCallback(
    (event) => {
      const newValue = event.target.value;
      setSelectedValue(newValue);
      onSelectChange(newValue);
    },
    [onSelectChange]
  );

  return (
    <FormControl required={required || false} sx={{ width: "100%", height: "100%", minWidth: 200 }}>
      <Select
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          width: "100%",
          height: "100%",
          p: 1,
          "& .MuiOutlinedInput-input": { p: 0 },
          "& .MuiSelect-select": { p: 0 },
        }}
      >
        <MenuItem value="">
          <em>{text}</em>
        </MenuItem>
        {Array.isArray(categoryData) &&
          categoryData.map((item) => (
            <MenuItem key={item[valueKey]} value={item[valueKey]}>
              {item[labelKey]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
